/**
 * The file name from a `Content-Disposition` header's RFC 5987 `filename*=UTF-8''…` parameter,
 * or null when the header lacks one or it does not decode.
 */
export function filenameFromContentDisposition(header: string | null): string | null {
  const encoded = header?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  if (!encoded) return null;
  try {
    return decodeURIComponent(encoded);
  } catch {
    return null;
  }
}
